import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { ROLE } from '@/shared/data/permissionSystem.js'

export const useCurrentUser = () => {
  const page = usePage()

  const currentUser = computed(() => page.props.currentUser)
  const timezone = computed(() => {
    const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const timezone =
      currentUser.value.accessControl.role !== ROLE.GUEST
        ? currentUser.value.timezone || defaultTimezone
        : defaultTimezone
    if (!timezone) return 'Invalid timezone'
    return timezone
  })

  return {
    currentUser,
    timezone,
  }
}
